import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import HandsOnMobile from "../assets/img/handsonmobile.jpg";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "../common/sharedFunctions";

const DownloadApp = () => {
  const settings = useSelector((state) => state.settingsdata.settings);
  const { t } = useTranslation();
  return (
    <Box component="section" sx={{ bgcolor: "#0B1739", color: "white", px: { xs: 2.5, md: 6 }, py: { xs: 8, md: 11 } }}>
      <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center" sx={{ maxWidth: 1100, mx: "auto" }}>
        <Grid item xs={12} md={5}><Box component="img" src={HandsOnMobile} alt="QC.Taxi mobile app" sx={{ display: "block", width: "100%", maxHeight: 440, objectFit: "cover", borderRadius: 5, boxShadow: "0 25px 60px rgba(0,0,0,.35)" }} /></Grid>
        <Grid item xs={12} md={7}>
          <Typography sx={{ color: "#FFD43B", fontFamily: FONT_FAMILY, fontWeight: 800, fontSize: 13, letterSpacing: 1.2, textTransform: "uppercase" }}>{t("landing_app_eyebrow")}</Typography>
          <Typography component="h2" sx={{ mt: 1, maxWidth: 600, fontFamily: FONT_FAMILY, fontWeight: 800, fontSize: { xs: 36, md: 52 }, letterSpacing: "-.045em", lineHeight: 1.05 }}>{t("landing_app_title")}</Typography>
          <Typography sx={{ mt: 2, mb: 4, maxWidth: 560, color: "rgba(255,255,255,.7)", fontFamily: FONT_FAMILY, fontSize: 17, lineHeight: 1.65 }}>{t("landing_app_text")}</Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
            {settings && settings.AppleStoreLink && <a href={settings.AppleStoreLink} target="_blank" rel="noreferrer"><img src={require("../assets/img/appstore.png").default} alt="Download on the App Store" style={{ height: 48 }} /></a>}
            {settings && settings.PlayStoreLink && <a href={settings.PlayStoreLink} target="_blank" rel="noreferrer"><img src={require("../assets/img/playstore.png").default} alt="Get it on Google Play" style={{ height: 48 }} /></a>}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
export default DownloadApp;
